import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import { IdempotencyKeyProvider } from '../../../services/idempotency-key.provider';
import {
  CreateWompiPaymentOrderRequest,
  PaymentOrderStatusResponse,
  WompiPaymentOrderResponse
} from '../models/payment.model';

@Injectable({ providedIn: 'root' })
export class WompiPaymentsApiService {
  constructor(
    private readonly api: ApiService,
    private readonly idempotencyKey: IdempotencyKeyProvider
  ) {}

  createPaymentOrder(body: CreateWompiPaymentOrderRequest): Observable<WompiPaymentOrderResponse> {
    const headers = new HttpHeaders({
      'Idempotency-Key': this.idempotencyKey.generate()
    });
    return this.api.post<WompiPaymentOrderResponse>('payments/wompi/payment-order', body, headers);
  }

  getPaymentOrderStatus(paymentOrderId: number): Observable<PaymentOrderStatusResponse> {
    return this.api.get<PaymentOrderStatusResponse>(`payments/orders/${paymentOrderId}`);
  }
}
